import Box from "@mui/material/Box";
import { IconButton, MenuItem } from "material-ui";
import { FormControl, InputAdornment, InputLabel, Select } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers-v6";

const CarrierSelected = ({
  isSmallerThanTablet = false,
  dataSearch = {},
  setDataSearch = () => {},
}) => {
  const carriers = [
    "จัดส่งโดยร้านค้า",
    "Lalamove",
    // "J&T Express",
    // "Best Express",
    // "Nim Express",
    // "ไปรษณีย์ไทย",
    "อื่นๆ",
  ];

  return (
    <Box
      sx={{
        minWidth: 200,
        display: isSmallerThanTablet ? "none" : "flex",
      }}
    >
      <FormControl fullWidth>
        <InputLabel>ขนส่ง</InputLabel>
        <Select
          value={dataSearch.carrier}
          label="carrier"
          onChange={(e) =>
            setDataSearch({
              ...dataSearch,
              carrier: e.target.value,
              page: 0,
            })
          }
          endAdornment={
            dataSearch.carrier && (
              <InputAdornment sx={{ marginRight: "10px" }} position="end">
                <IconButton
                  onClick={() => {
                    setDataSearch({
                      ...dataSearch,
                      carrier: "",
                      page: 0,
                    });
                  }}
                >
                  <ClearIcon
                    sx={{
                      "&.MuiSvgIcon-root": {
                        fill: "#6C6C70",
                      },
                    }}
                  />
                </IconButton>
              </InputAdornment>
            )
          }
        >
          {carriers.map((item) => (
            <MenuItem value={item} key={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default CarrierSelected;
